/* Quick Shop modal: re-run injected scripts, mirror `--sh-*` CSS vars,
   and nudge app blocks so bundle/upsell radios work inside the modal. */
(function () {
  'use strict';

  function executeScripts(root) {
    if (!root) return;
    var scripts = root.querySelectorAll('script');
    scripts.forEach(function (oldScript) {
      var newScript = document.createElement('script');
      // copy attributes (src, type, data-*, etc.)
      for (var i = 0; i < oldScript.attributes.length; i++) {
        var attr = oldScript.attributes[i];
        newScript.setAttribute(attr.name, attr.value);
      }
      if (oldScript.textContent) {
        newScript.textContent = oldScript.textContent;
      }
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  function dispatchSectionLoad(productSection) {
    if (!productSection) return;
    var sectionId = productSection.getAttribute('data-section-id');
    if (!sectionId) return;

    try {
      document.dispatchEvent(
        new CustomEvent('shopify:section:load', {
          bubbles: true,
          detail: { sectionId: sectionId, load: true }
        })
      );
    } catch (e) { /* ignore */ }
  }

  function refreshCheckedRadios(productSection) {
    if (!productSection) return;
    var radios = productSection.querySelectorAll('input[type="radio"]:checked');
    radios.forEach(function (radio) {
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      radio.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  /* --------------------------------------------------------------------------
     Mirror Section Heroes (and any `--sh-*`) CSS variables from the document
     stylesheets onto the modal element. The app's bundle/upsell CSS uses
     `var(--sh-bundle-box-bg-active, ...)` etc. These variables are defined
     in a scope the modal DOM doesn't inherit from, so rules that rely on
     them resolve to nothing and the layout looks broken. Copying the
     resolved values onto `.modal--quick-shop` makes the app's own CSS work.
     -------------------------------------------------------------------------- */
  function mirrorShCssVariables(modal) {
    if (!modal) return;
    var collected = {};

    function harvestRule(rule) {
      if (!rule || !rule.style) return;
      for (var i = 0; i < rule.style.length; i++) {
        var prop = rule.style[i];
        if (prop.indexOf('--sh-') === 0) {
          var val = rule.style.getPropertyValue(prop);
          if (val) collected[prop] = val.trim();
        }
      }
    }

    function walkRules(rules) {
      if (!rules) return;
      for (var i = 0; i < rules.length; i++) {
        var rule = rules[i];
        if (rule.cssRules) walkRules(rule.cssRules); // @media, @supports, etc.
        harvestRule(rule);
      }
    }

    for (var s = 0; s < document.styleSheets.length; s++) {
      var sheet = document.styleSheets[s];
      try { walkRules(sheet.cssRules); } catch (e) { /* CORS, skip */ }
    }

    // Inline custom properties on <html> and <body>
    [document.documentElement, document.body].forEach(function (el) {
      if (!el || !el.style) return;
      for (var i = 0; i < el.style.length; i++) {
        var prop = el.style[i];
        if (prop.indexOf('--sh-') === 0) {
          collected[prop] = el.style.getPropertyValue(prop).trim();
        }
      }
    });

    Object.keys(collected).forEach(function (name) {
      modal.style.setProperty(name, collected[name]);
    });
  }

  document.addEventListener('quickview:loaded', function (evt) {
    var productId = evt.detail && evt.detail.productId;
    if (!productId) return;

    var modal = document.getElementById('QuickShopModal-' + productId);
    if (!modal) return;

    var productSection = modal.querySelector('[data-section-type="product"]');
    if (!productSection) return;

    // (a) re-run scripts that rode in with the AJAX-loaded blocks
    executeScripts(productSection);

    // (b) mirror any --sh-* CSS variables from the page onto the modal so
    //     the Section Heroes Bundle/Upsell CSS resolves correctly
    mirrorShCssVariables(modal);

    // (c) let section-aware apps (Fast Bundle, Judge.me, etc.) pick up
    // (d) nudge any app that derives state from the selected radio
    setTimeout(function () {
      dispatchSectionLoad(productSection);
      refreshCheckedRadios(productSection);
    }, 60);
  });
})();
